import { DataResult, DataStream, WidgetSettingsType } from '@thingslog/repositories';
import { DataResultParseStrategy } from './DataResultParseStrategy';
import { DataResultParsed, DataResultParseStream } from '../DataResultParsed';
import { t } from 'i18next';

export class ApiAlarmsCountDataResultParseStrategy implements DataResultParseStrategy {
  public parse(dataResult: DataResult, widgetType: WidgetSettingsType): DataResultParsed {
    const parsed: DataResultParsed = {
      dataStreams: [],
      xAxis: {
        show: true,
        dataKey: 'alarmType',
        name: t('dashboard_alarm_type', 'Alarm Type'),
        formatter: (value: string) => value,
      },
      yAxis: {
        show: true,
        name: t('function_count', 'Count'),
        formatter: (value: number) => value.toLocaleString(),
      },
      legend: {
        show: true,
      },
      tooltip: {
        labelFormatter: (value: string | number): string => String(value),
      },
    };

    const countByAlarmType = new Map<string, number>();

    dataResult.streams.forEach((stream: DataStream) => {
      if (stream.type !== 'series' || stream.data.length !== 1) {
        return;
      }

      const alarmType = stream.metaData.alarmType;
      const count = stream.data[0];

      if (!alarmType || !Number.isFinite(count)) {
        return;
      }

      countByAlarmType.set(alarmType, (countByAlarmType.get(alarmType) ?? 0) + count);
    });

    const dataStream: DataResultParseStream = {
      data: Array.from(countByAlarmType.entries()).map(([alarmType, count]: [string, number]) => ({
        alarmType,
        count,
      })),
      visualization: [
        {
          dataKey: 'count',
          fill: '#0ea5e9',
          innerRadius: 56,
          outerRadius: 86,
          name: t('dashboard_alarm_count', 'Alarm count'),
          nameKey: 'alarmType',
          colorByDataPoint: true,
        },
      ],
    };

    parsed.dataStreams.push(dataStream);

    return parsed;
  }
}
